import { PermissionResource } from '@entities/client/permission';

import { requirePermission } from '../../../require-permission';

export const driversLoader = requirePermission(PermissionResource.ClientDrivers);
